import React, { Component, createRef, useState, memo } from 'react'
import PropTypes from 'prop-types'
import { v4 as uuid } from 'uuid'
import { Tooltip, Link } from '@mui/material'
import { Logger, LoggerTypes } from '../../../utils'

/**
 * The ButtonPopUp component can be used to display a rounded text that open a popin onClick
 * Ex:
 *  - project = {name: '', id: 456, ...}
 *  - <ButtonPopUp
 *      text={<Deletetext/>}
 *      element={project}
 *      DialogClass={ProjectDialogDelete}
 *      tooltip={t('common.delete')}
 *    />
 * @returns {DialogClass}
 */
const ButtonPopUp = ({ DialogClass, text, tooltip, element, params, extraDialogAttribute, style, disabled }) => {
  const [openDialog, setOpenDialog] = useState(false)

  const ref = createRef()
  // TODO: Replace this by extraDialogAttribute:
  const { pid, sid, fid, vid, rid, mid, wid, lid, did } = params
  const uuidVal = uuid()
  const isTooltip = tooltip && typeof tooltip === 'string' && tooltip.length > 0

  const onClick = (e) => {
    e.stopPropagation()
    e.preventDefault()

    Logger.trace(LoggerTypes.CONTROLLER, 'ButtonPopUp.onClick()', { params, e })

    setOpenDialog(!openDialog)
  }

  const dialog = (
    <DialogClass
      ref={ref}
      pid={pid}
      sid={sid}
      fid={fid}
      vid={vid}
      rid={rid}
      mid={mid}
      wid={wid}
      lid={lid}
      did={did}
      project={element}
      scenario={element}
      flowGroup={element}
      variable={element}
      resource={element}
      product={element}
      weather={element}
      location={element}
      parameter={element}
      openDialog={openDialog}
      setOpenDialog={setOpenDialog}
      {...extraDialogAttribute}
    />
  )

  // Logger.trace(LoggerTypes.CONTAINER, 'ButtonPopUp.render()', {
  //   pid, // Project ID
  //   sid, // Scenario ID
  //   fid, // FlowGroup ID
  //   vid, // Variable ID
  //   rid, // Resource ID
  //   mid, // Parameter ID
  //   wid, // Weather ID
  //   lid, // Location ID
  //   did, // Product ID
  //   element,
  //   extraDialogAttribute
  // })

  return (
    <React.Fragment key={`ButtonPopUp-${uuidVal}`}>
      {isTooltip ? (
        <Tooltip ref={ref} title={tooltip}>
          <div>
            <Link
              href="#"
              onClick={(e) => {
                if (!disabled) {
                  onClick(e)
                }
              }}
              disabled={disabled}
              style={style}
              label="Click for action"
            >
              {text}
            </Link>
          </div>
        </Tooltip>
      ) : (
        <Link
          href="#"
          onClick={(e) => {
            if (!disabled) {
              onClick(e)
            }
          }}
          disabled={disabled}
          style={style}
          label="Click for action"
        >
          {text}
        </Link>
      )}
      {openDialog ? dialog : null}
    </React.Fragment>
  )
}

ButtonPopUp.displayName = 'ButtonPopUp'

ButtonPopUp.propTypes = {
  DialogClass: PropTypes.any.isRequired,
  text: PropTypes.any.isRequired,
  element: PropTypes.object,
  params: PropTypes.object,
  tooltip: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  extraDialogAttribute: PropTypes.shape({
    title: PropTypes.string,
    dispatchAction: PropTypes.func
  })
}

ButtonPopUp.defaultProps = {
  DialogClass: Component,
  text: null,
  element: {},
  params: {},
  tooltip: null,
  style: null,
  disabled: false,
  extraDialogAttribute: {}
}

export default memo(ButtonPopUp)
